import type { State, ListedCompany } from './vuex';

export default {
  setCompanies(state: State, companies: ListedCompany[]): void {
    state.companies = companies;
  },
};
